import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="border-t border-[#1D3557]/5 bg-[#F8FAFA] py-10"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Logo size={20} />
            <span className="font-heading font-black text-sm uppercase tracking-tight text-[#1D3557]">
              target<span className="text-[#E63946]">funder</span><span className="text-[#1D3557]/30">.com</span>
            </span>
          </div>

          <p className="font-body text-xs text-[#1D3557]/30">
            &copy; {year} TargetFunder. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="/terms"
              className="font-body text-xs text-[#1D3557]/40 hover:text-[#1D3557] transition-colors"
              data-testid="footer-terms"
            >
              Terms & Conditions
            </a>
            <a
              href="mailto:enquiries@targetfunder.com"
              className="font-body text-xs text-[#1D3557]/40 hover:text-[#1D3557] transition-colors"
              data-testid="footer-email"
            >
              enquiries@targetfunder.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
